export default "__VITE_ASSET__Bzz$zJEA__"